import { render } from "./TraitRanksFiltersApes.vue?vue&type=template&id=a34c4a28"
import script from "./TraitRanksFiltersApes.vue?vue&type=script&lang=js"
export * from "./TraitRanksFiltersApes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__